import { Box } from '@tempmee/react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

const WRAPPER_STYLE = { marginBottom: 12 };

// decorative; title conveys the warning
export const PopupWarningIcon = () => (
  <Box style={WRAPPER_STYLE}>
    <SolidExclamationWarningAlertIcon size={80} color={colors.warning[500]} aria-hidden="true" />
  </Box>
);
